import { createFileRoute } from "@tanstack/react-router";
import { ApiKeysSettings } from "@/features/api-keys";
import { useAuth } from "@/features/auth";

function ApiKeysPage() {
  const { user } = useAuth();
  return <ApiKeysSettings userId={user.id} />;
}

export const Route = createFileRoute("/_authenticated/account/api-keys")({
  component: ApiKeysPage,
});
